import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { isIE } from '../../common/utils';
import { getRepiSetting } from '../../../store/storeFunctions';
import { repiActions, searchTypes } from '../../../store/repiStore';
import BbCheckbox from '../../styling/bbCheckbox';
import RepiSearchManagerTooltip from './repiSearchManagerTooltip';

import './repiSearchManager.scss'

class RepiSearchManager extends React.Component {
    state = {
        sharedRegTooltip: false,
        searchMethodTooltip: false
    };

    render() {
        return (
            <div className={classnames("search-results-manager-wrapper is-sticky", {
                "relative": isIE() && !this.props.layout.scrolled,
                "fixed": isIE() && this.props.layout.scrolled,
                "hide-on-mobile":  this.props.isMobile}
            )}>
                <div className={classnames("search-results-manager repi-search-manager-wrapper", { "tinted": this.props.tinted })}>
                    {this.renderLeftSide()}
                </div>
            </div>
        );
    }

    renderLeftSide = () => {
        return (
            <div className="repi-search-manager-left">
                <div className="repi-search-manager-item">
                    <Translate id="Repi.Search.SearchType" />
                    <div className={classnames("settings-selector", { "wide" : this.props.userLanguage === "de-DE" })}>
                        <span data-active={this.props.search.searchType ===  searchTypes.fullText}
                            onClick={() => this.props.updateSearchParams({ searchType: searchTypes.fullText })}
                        >
                            <Translate id="Repi.Search.Type.FullText" />
                        </span>
                        <span data-active={this.props.search.searchType ===  searchTypes.exactMatch}
                            onClick={() => this.props.updateSearchParams({ searchType: searchTypes.exactMatch })}
                        >
                            <Translate id="Repi.Search.Type.ExactMatch" />
                        </span>
                    </div>
                    <RepiSearchManagerTooltip id="searchMethodTooltip" trKey="Repi.Search.SearchMethod.Tooltip" />
                </div>
                {getRepiSetting("allowSharing", false) && !this.state.searchMethodTooltip && <div className="repi-search-manager-item">
                    <BbCheckbox id="search-shared-registry"
                        label={this.props.translate("Repi.Search.SharedRegistry")}
                        value={this.props.search.sharedRegistry}
                        onChange={(value) => this.props.updateSearchParams({ sharedRegistry: value })}
                    />
                    <RepiSearchManagerTooltip id="sharedRegTooltip" trKey="Repi.Search.SharedRegistry.Tooltip" />
                </div>}
            </div>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => ({
        search: state.repi.search,
        userLanguage: state.userContext.language
    }),
    dispatch => bindActionCreators(repiActions, dispatch)
)(RepiSearchManager)));
